<script setup>
import { computed, defineAsyncComponent } from "vue";

const networks = {
    facebook: defineAsyncComponent(() => import("./icons/Facebook.vue")),
    instagram: defineAsyncComponent(() => import("./icons/Instagram.vue")),
    linkedin: defineAsyncComponent(() => import("./icons/Linkedin.vue")),
    tiktok: defineAsyncComponent(() => import("./icons/Tiktok.vue")),
    twitter: defineAsyncComponent(() => import("./icons/Twitter.vue")),
    youtube: defineAsyncComponent(() => import("./icons/Youtube.vue")),
};

const Default = defineAsyncComponent(() => import("./icons/Default.vue"));

const props = defineProps({
    items: {
        type: Array,
        default: () => [],
    },
});

const resolvedItems = computed(() =>
    props.items.map((item) => ({
        ...item,
        component: networks[item.name.toLowerCase()] || Default,
    })),
);
</script>

<template>
    <div class="inline-flex gap-1 justify-center items-center mr-2" v-if="items">
        <a
            v-for="item in resolvedItems"
            :key="item.name"
            data-external="true"
            :href="item.value"
            class="h-8 w-8 rounded-full inline-flex justify-center items-center"
        >
            <component :is="item.component" class="h-7 w-7" />
        </a>
    </div>
</template>
